import { createContext } from 'react';

// The inspection's Activity Status as currently picked in the editor. A field
// the builder made "required only when the result is…" (fillLayout
// isRequiredField) needs it to know whether it is required right now, and every
// field component reads it from here rather than having it threaded through
// FillThresholdReport's three render paths.
const FormStatusContext = createContext<string | undefined>(undefined);

export default FormStatusContext;
